import { useState } from 'react';

import { Locale } from 'chaika-enums';
import { TranslationsData } from 'chaika-frontend-types/frontend-cms';

import { OptionType } from '@components/Select';
import { makeOptionType } from '@utils/makeOptionTypes';
import { getLocaleArray } from '@utils/CommonOptionType';
import { getLocaleTranslation } from '@utils/enumTranslation';

interface Props {
    value: TranslationsData[];
    onChange(params: any): void;
}

interface Data {
    languagesList: Locale[];
    selectedTranslations: TranslationsData[];
    options: OptionType<string>[];
    onDelete(index: number): void;
    onItemChange(params: Partial<TranslationsData>, index: number): void;
}

export function useTranslationEditor({ value = [], onChange }: Props): Data {
    const languagesList = getLocaleArray(Locale.Ru);
    const [selectedTranslations, setSelectedTranslations] = useState<TranslationsData[]>(value);

    const options: OptionType<string>[] = makeOptionType(
        languagesList.map(lang => ({ id: lang, name: getLocaleTranslation(lang) })),
    );

    function onItemChange(params: Partial<TranslationsData>, index: number): void {
        const newState: TranslationsData[] = [];

        setSelectedTranslations(prevState => {
            newState.push(...prevState);
            newState[index] = { ...prevState[index], ...params };
            return newState;
        });

        onChange(newState);
    }

    function onDelete(index: number): void {
        const newState: TranslationsData[] = [];

        setSelectedTranslations(prevState => {
            newState.push(...prevState.slice(0, index), ...prevState.slice(index + 1, prevState.length));

            return newState;
        });

        onChange(newState);
    }

    return {
        languagesList,
        selectedTranslations,
        options,
        onDelete,
        onItemChange,
    };
}
